import type { TrendDirection } from '@/types/content';

const trendConfig: Record<TrendDirection, { icon: string; label: string; className: string }> = {
  up: { icon: 'ri-arrow-up-line', label: '上升', className: 'bg-primary-100 text-primary-700' },
  down: { icon: 'ri-arrow-down-line', label: '回落', className: 'bg-secondary-100 text-secondary-800' },
  new: { icon: 'ri-sparkling-fill', label: '新上榜', className: 'bg-accent-100 text-accent-900' },
  flat: { icon: 'ri-subtract-line', label: '持平', className: 'bg-background-200 text-foreground-600' },
};

interface TrendBadgeProps {
  trend: TrendDirection;
  value: string;
  compact?: boolean;
}

export default function TrendBadge({ trend, value, compact = false }: TrendBadgeProps) {
  const config = trendConfig[trend];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${config.className}`}
    >
      <i className={config.icon} />
      {!compact && <span>{value}</span>}
    </span>
  );
}